import { createSlice } from '@reduxjs/toolkit'

export const slice = createSlice({
  name: 'menu',
  initialState: {
    menuVisibility: true,
    showUserMenu: false,
    standaloneMessageShown: false,
    isContainerEditorShown: false,
  },
  reducers: {
    setShowUserMenu (state, { payload = false }) {
      state.showUserMenu = payload
    },
    openMain: state => {
      state.menuVisibility = true
    },
    closeMain: state => {
      state.menuVisibility = false
    }
  },
})

export const { openMain, closeMain, setShowUserMenu, toggleStandaloneMessageShown, toggleContainersEditorShown } = slice.actions

export default slice.reducer
